import React from "react";
import { useTranslation, Trans } from "react-i18next";

const Oneliner = () => {
  useTranslation();

  return (
    <section className="oneliner-container" aria-labelledby="oneliner-section">
      <h3 id="oneliner-section">
        <Trans i18nKey="oneliner.title">
          I’m a <span className="highlight">Visionary</span> Inventor,
          Consultant, and Entrepreneur, creating impact and inspiring growth.
        </Trans>
      </h3>
    </section>
  );
};

export default Oneliner;
